import { render, staticRenderFns } from "./accountManagementForm.vue?vue&type=template&id=265e12ea&scoped=true"
import script from "./accountManagementForm.vue?vue&type=script&lang=js"
export * from "./accountManagementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265e12ea",
  null
  
)

export default component.exports